<template>
    <div class="menu-container">
        <span>{{ priorityUpdate }}</span>
        <span>{{ challengeUpdate }}</span>
        <span>{{ horizonUpdate }}</span>
    </div>
</template>

<script>
export default {
    name: 'MenuAttributeCompact',
    props: {
        attribute: {
            type: Object,
        },
    },
    computed: {
        priorityUpdate() {
            return this.attribute.priority_level
                ? `P${this.attribute.priority_level}`
                : ''
        },
        challengeUpdate() {
            return this.attribute.challenge_level
                ? `
                    ${this.$t('strategy.compactMode.challenge.sigla')}${
                      this.attribute.challenge_level
                  }`
                : ''
        },
        horizonUpdate() {
            return this.attribute.horizon_one_page_id
                ? `H${this.attribute.horizon_one_page_id}`
                : ''
        },
    },
}
</script>

<style lang="sass" scoped>
.menu-container
    display: flex
    justify-content: end
    font-size: 1.3rem
    span
        margin-left: .5rem
    span:first-child
        color: #E7A42F
    span:nth-child(2)
        color: #009ADA
    span:nth-child(3)
        color: #6E6E6E
</style>
